import { useState, useEffect } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Flex, useToast } from "@chakra-ui/react";
import { copyToUserClipboard, triggerLaunchdeckToast } from '../../global/helpers/global-helpers';
import DefaultSpinner from '../../global/components/helper-components/components/DefaultSpinner';
import { getDsrInviteLink, resetGetDsrInviteLink } from '../actions/dsr-invite-actions';


function CopyInviteLinkModule({
  dsrId,
  invitedMemberUserId,
  isMobileView,
  // Action
  getDsrInviteLink,
  resetGetDsrInviteLink,
  // Redux
  getDsrInviteLinkOutcome,
}) {

  // If no tempInviteToken inside userMetadata, then generate one and return it.
  const toast = useToast();
  const [isLoading, setIsLoading] = useState("")
  const [isCopiedStatus, setIsCopiedStatus] = useState(false)

  // UX management
  useEffect(() => {
    if (getDsrInviteLinkOutcome) {
      const { dsrInviteLink, invitedMemberUserId: inviteLinkRecipientUserId } = getDsrInviteLinkOutcome || {}
      if (dsrInviteLink && (inviteLinkRecipientUserId === invitedMemberUserId)) {
        copyToUserClipboard(dsrInviteLink)
      } else if (!dsrInviteLink) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Unfortunately something went wrong. Please try again later.",
            isMobileView
          })
        )
      }
      setIsCopiedStatus((inviteLinkRecipientUserId === invitedMemberUserId))

      setIsLoading(false)
      resetGetDsrInviteLink()
    }

  }, [getDsrInviteLinkOutcome]);

  const handleCopyLink = () => {
    setIsLoading(!isLoading)
    getDsrInviteLink({ dsrId, invitedMemberUserId })
  }


  if (isLoading) {
    return (
      <Flex px='1em'>
        <DefaultSpinner />
      </Flex>
    )
  } else if (isCopiedStatus) {
    return (
      <Flex className='fade-in' color='brandGreen.500' fontSize='0.9em' fontWeight='600' gap={2} align='center' justify='flex-start' cursor='pointer' onClick={() => handleCopyLink()}>
        Invite link copied
      </Flex>
    )
  }

  return (
    <Flex color='brandPink.500' fontSize='0.9em' cursor='pointer' onClick={() => handleCopyLink()}>
      Invite again
    </Flex>
  )

}


const mapStateToProps = (state) => ({
  getDsrInviteLinkOutcome: state.getDsrInviteLinkOutcome.results.data,
  isMobileView: state.mobileViewMode.isMobileView
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDsrInviteLink,
      resetGetDsrInviteLink
    },
    dispatch,
  )



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CopyInviteLinkModule));
